import FeatureFlagsContext from './context';

export const FeatureFlagsContextProvider = FeatureFlagsContext.Provider;
